/* eslint-disable react/destructuring-assignment */
import React from "react"
import { useSelector } from "react-redux"

import {
    StoreType,
    getFile,
    createFileName,
    LangType,
} from "client/store"
import {
    HistoryProps,
    HistoryType,
    ComplianceHistory,
} from "client/components"
import {
    Attachment,
    Bold,
} from "./styled"

export const HistoryAttachment = ({
    history,
}: HistoryProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const complianceHistory = history as ComplianceHistory
    const { versions } = complianceHistory

    if (versions && versions.length > 0) {
        return (
            <Attachment>
                <Bold>{`${lang.attachments}:`}</Bold>
                <ul style={{ margin: "0" }}>
                    {
                        versions.map((row) => {
                            const { version } = row
                            const fileHref = getFile(version.file, version).download
                            const fileName = `${createFileName(version.file)} - ${lang.revision} ${version.revision}`
                            return (
                                <li key={version.id}>
                                    <a href={fileHref} target="_blank" rel="noreferrer" title={fileName}>
                                        {fileName}
                                    </a>
                                </li>
                            )
                        })
                    }
                </ul>
            </Attachment>
        )
    }
    return null
}

export const HistoryAttachmentPdfExport = (
    history: HistoryType,
    lang: LangType,
) => {
    const complianceHistory = history as ComplianceHistory
    const { versions } = complianceHistory

    if (versions && versions.length > 0) {
        const versionsList: any[] = []
        versions.forEach((row) => {
            const { version } = row
            const fileHref = getFile(version.file, version).download
            const fileName = `${createFileName(version.file)} - ${lang.revision} ${version.revision}`

            versionsList.push({
                text: fileName,
                color: "blue",
                decoration: "underline",
                link: fileHref,
            })
        })

        return ({
            stack: [
                {
                    text: `${lang.attachments}: `,
                    bold: true,
                },
                {
                    margin: [30, 5, 0, 5],
                    lineHeight: 1.25,
                    ul: versionsList,
                },
            ],
        })
    }
    return null
}
